import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { TaskTypesDropdownProps, TaskTypesRespSuccess } from './types';
import { useAppContext } from '@contexts/app';
import { useQueryParams } from '@hooks/queryParams';

export const useTaskTypesDropdown = ({
  workflowIds: workflowIdsOverride,
  enabled: enabledOverride = true,
}: TaskTypesDropdownProps = {}) => {
  const { isDropdownEnabled } = useAppContext();
  const enabled = Boolean(isDropdownEnabled) && enabledOverride;

  const {
    params: { workflowIds, stages: stageNames },
    parseParams,
  } = useQueryParams();

  const queryParams = parseParams(
    { workflowIds: workflowIdsOverride ?? workflowIds, stageNames },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending } = useQuery<TaskTypesRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.taskTypes, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/task_types${queryParams}` }),
    enabled,
    placeholderData: (previousData) => previousData as TaskTypesRespSuccess,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
